import React from "react";
import { motion } from "framer-motion";
import { useHome } from "@/i18n/home";

export const TrustBar = () => {
  const tr = useHome().trust;
  const STATS = [
    { v: "4,9/5", l: tr.rating },
    { v: "100%", l: tr.focus },
    { img: "/unifi-uwa.png", l: "UniFi Wireless Administrator" },
  ];
  return (
  <section className="relative border-y border-[#E5E7EB] bg-white" data-testid="trust-bar">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-8">
      <p className="text-center text-xs uppercase tracking-[0.22em] font-semibold text-[#0B87B0] mb-6">
        {tr.title}
      </p>
      <div className="grid grid-cols-3 gap-4 divide-x divide-[#E5E7EB]">
        {STATS.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="flex flex-col items-center px-2 text-center"
            data-testid={`trust-stat-${i}`}
          >
            {s.img ? (
              <img src={s.img} alt={s.l} className="h-11 w-auto object-contain" data-testid="trust-uwa-logo" />
            ) : (
              <span className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#090A0C]">{s.v}</span>
            )}
            <span className="mt-1 text-[11px] sm:text-xs uppercase tracking-[0.14em] text-[#4B5563]">{s.l}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
  );
};
